export default {
  mainWorkflow: {
    organizationId: null,
    workflowStatus: null,
    name: null,
    workflowJson: {
      id: null,
      triggers: {
        values: [],
      },
      steps: {
        values: [],
      },
    },
  },
  automationDetail: {
    expanded: false,
  },
  currentStep: {
    currentStepType: null,
  },
  controls: {
    channelType: null,
    validation: {
      automationDetail: null,
      audience: null,
      action: null,
      content: null,
    },
    templateEmail: null,
  },
}

const triggerModel = {
  id: null,
  type: null,
  data: {
    segmentId: null,
    triggerDate: null,
    triggerOffsetInMinutes: null,
    timezone: null,
    useBirthdateFieldName: true,
    dateFieldName: null,
    schedulingTime: null,
  },
}

const stepEMAILModel = {
  templateId: null,
  senderId: null,
  subject: null,
  from: null,
  cc: null,
  bcc: null,
  contentType: null,
  displayName: null,
  replyTo: null,
  scheduleDateTime: null,
  expirationDateTime: null,
  beginTime: null,
  endTime: null,
  isWorkingDays: null,
  timezone: null,
}

const stepSMSModel = {
  templateId: null,
  senderId: null,
  text: null,
  senderName: null,
  scheduleDateTime: null,
  expirationDateTime: null,
  beginTime: null,
  endTime: null,
  isWorkingDays: null,
  timezone: null,
}
